import styled from "@emotion/styled";
import { LocalDate, LocalTime } from "@js-joda/core";
import React from "react";
import SelectTimeSlot, { DaySlot } from "../../../SelectTimeSlot";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppCard, AppCardContent, AppCardHeader, AppCardTitle } from "../../Generic/AppCard";

type Props =
  | {
      status: "loaded";
      slots: DaySlot[];
      message: string | null;
      selectedDate: LocalDate | null;
      selectedTime: LocalTime | null;
      shouldShowError: boolean;
      timeSlotAppCardRef?: React.RefObject<HTMLDivElement>;
      selectDateLabelRef?: React.RefObject<HTMLDivElement>;
      selectTimeLabelRef?: React.RefObject<HTMLDivElement>;
      onSelectDate: (date: LocalDate) => void;
      onSelectTime: (time: LocalTime) => void;
    }
  | {
      status: "loading" | "error";
    };

export default function SelectTaskTimeSlotCard(props: Props) {
  return (
    <CustomAppCard
      cardRef={props.status === "loaded" ? props.timeSlotAppCardRef : undefined}
      data-invalid={props.status === "loaded" && props.shouldShowError}
    >
      <AppCardHeader>
        <AppCardTitle>
          <Title>{translate(STRINGS.SELECT_TIME_SLOT)}</Title>
          <Subtitle>{translate(STRINGS.SELECT_TIME_SLOT_INFO)}</Subtitle>
        </AppCardTitle>
      </AppCardHeader>
      <AppCardContent>
        <SelectTimeSlot {...props} />
      </AppCardContent>
    </CustomAppCard>
  );
}

const Title = styled.span`
  margin-bottom: 8px;
  display: block;
`;

const Subtitle = styled.span`
  color: var(--tw-slate-500);
  font-weight: 400;
`;

const CustomAppCard = styled(AppCard)<{ "data-invalid": boolean }>`
  border-color: ${(props) => (props["data-invalid"] ? "var(--tw-red-500)" : "transparent")};
  border-width: 2px;
  border-style: solid;
`;
